import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import { dropDownStyles as styles, menuProps } from "./dropDownStyles";

const DropDown = ({ label, value, onChange, options, darkTheme }) => {
    return (
        <FormControl sx={styles.formControl} >
            <Select
                id="dropdown-select"
                value={value}
                onChange={onChange}
                displayEmpty 
                // sx={styles.select}
                sx={{
                    ...styles.select,
                    color: darkTheme ? "gray" : value ? "white" : "gray", // Placeholder should be gray
                    fontSize: "14px",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--borderColor) !important"
                    },
                }}
                // MenuProps={{
                //     PaperProps: {
                //       sx: styles.menu, // Apply the custom styles for the menu
                //     },
                //   }}
                inputProps={{ "aria-label": "Without label" }}
                MenuProps={menuProps}
            >
                <MenuItem disabled value="">
                    <em>{label}</em>
                </MenuItem>
                {options?.map((option) => (
                    <MenuItem key={option?.value} value={option?.value} sx={{
                        fontSize: "14px"
                     }}>
                        {option?.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DropDown;
